export default "__VITE_ASSET__385a7129__"